module.exports = __webpack_public_path__ + "static/img/service-qrcode.f5b0e42.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/service-qrcode.png
// module id = dMBf
// module chunks = 156